<template>
  <div class="bin-card-monitoring-container">
    <div class="row">
      <div class="col-lg-12 stretch-card">
        <div class="card">

          <!-- Body -->
          <div class="card-body">
            <!-- <h4 class="card-title">BIN Card Reports</h4> -->
            <h4 class="card-title">Inventory Level Report</h4>
            <div class="filters">
              <div class="row mb-3">
                <!-- Left Side -->
                <div class="col-lg-3 col-md-3 col-12 text-left d-flex flex-column">
                  
                  <button type="button" class="btn btn-primary btn-sm-block mt-1 ml-xl-2 ml-lg-2 ml-md-2 ml-sm-2 text-start" 
                    @click="uploadModalShow = true">
                    <i class="fas fa-upload"></i>
                    <!-- Upload BIN Card Raw File -->
                    Upload Inventory Level Raw File
                  </button>
                  <button type="button" class="btn btn-primary btn-sm-block mt-1 ml-xl-2 ml-lg-2 ml-md-2 ml-sm-2 text-start" 
                    @click="showValidatorModal = true">
                    <i class="fas fa-download"></i>
                    Generate Inventory Level Validator
                  </button>
                  <button type="button" class="btn btn-primary btn-sm-block mt-1 ml-xl-2 ml-lg-2 ml-md-2 ml-sm-2 text-start" 
                    @click="downloadTemplate">
                    <i class="fas fa-download"></i>
                    Download Inventory Level Template
                  </button>

                </div>

                <!-- Center Side -->
                <div class="col-lg-3 col-md-3 col-12">
                </div>
                <div class="col-lg-3 col-md-3 col-12">
                </div>

                <!--Right Side-->
                <div class="col-lg-3 col-md-3 col-12 text-right">
                  <button type="button" class="btn btn-primary btn-sm-block mt-1 ml-xl-2 ml-lg-2 ml-md-2 ml-sm-2"
                    @click="inventoryLevelReportModal = true">
                    <i class="fas fa-file-export"></i>
                    <!-- Generate Stock On Hand Report -->
                    Generate Inventory Level Report
                  </button>
                </div>
                
              </div>
            </div>
            <div>
              <lottie-animation style="height: 500px" :loop="true"
                :animationData="require('@/assets/lottie/report.json')" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- upload modal -->
    <b-modal v-model="uploadModalShow" size="md" title="Inventory Level" hide-footer no-close-on-backdrop>
      <form class="forms-sample">
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label for="txtFirstName">Raw File</label>
              <input class="form-control" type="file" v-on:change="handleFileUpload($event)"
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" />
            </div>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col">
            <!-- <button type="button" class="btn btn-primary mr-2" @click="uploadFile"> -->
            <button type="button" class="btn btn-primary mr-2" @click="uploadFileV2">
              Upload
            </button>
            <button type="button" class="btn btn-light" @click="uploadModalShow = !uploadModalShow">
              Cancel
            </button>
          </div>
        </div>
      </form>
    </b-modal>

    <!-- generate report modal -->
    <b-modal v-model="inventoryLevelReportModal" size="md" title="Inventory Level Report" hide-footer no-close-on-backdrop>
      <form class="forms-sample">
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label for="chkReportType">Report Type</label>
              <div class="row">
                <div class="col">
                  <div class="form-check">
                    <label class="form-check-label">
                      <input type="radio" class="form-check-input" value="principal" v-model="reportType"
                        :disabled="isGenerating" />
                      Principal Report
                      <i class="input-helper"></i></label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label for="txtReportDateRange">Report Date</label>
              <!-- <date-picker v-model="stockOnHandReportFilter.date" :clearable="false" format="MM/DD/YYYY" -->
              <date-picker v-model="inventoryLevelReportFilter.date" :clearable="false" format="MM/DD/YYYY" 
                title-format="MM/DD/YYYY" time-title-format="MM/DD/YYYY" input-class="form-control"
                :input-attr="{ id: 'txtReportDateRange' }" :disabled="isGenerating" single></date-picker>
            </div>
          </div>
        </div>
        <div class="row" v-if="reportType == 'principal'">
          <div class="col">
            <div class="form-group">
              <label for="txtPrincipalCode">Principal Code</label>
              <multiselect id="txtPrincipalCode" v-model="value" placeholder="Search Principal Code" label="name"
                track-by="code" :options="principalOptions" :multiple="true"></multiselect>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-check form-check-flat form-check-primary">
              <label class="form-check-label">
                <!-- <input type="checkbox" class="form-check-input" v-model="stockOnHandReportFilter.isOfficial" -->
                <input type="checkbox" class="form-check-input" v-model="inventoryLevelReportFilter.isOfficial"
                  :disabled="isGenerating" />
                Is Official
                <i class="input-helper"></i></label>
            </div>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col">
            <button type="button" class="btn btn-primary mr-2" @click="generateInventoryLevelReport"
              :disabled="isGenerating">
              <i class="fas fa-spinner fa-spin mr-1" v-if="isGenerating" />
              Generate
            </button>
            <button type="button" class="btn btn-light" @click="
                          inventoryLevelReportModal = !inventoryLevelReportModal;
                        reportType = 'principal';
                        " :disabled="isGenerating">
              Cancel
            </button>
          </div>
        </div>
      </form>
    </b-modal>

    <!-- validator report modal -->
     <b-modal v-model="showValidatorModal" size="md" title="Inventory Level Report" hide-footer no-close-on-backdrop>
      <form class="forms-sample">
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label for="txtReportDateRange">Report Date</label>
              <date-picker v-model="inventoryLevelReportFilter.date" :clearable="false" format="MM/DD/YYYY" 
                title-format="MM/DD/YYYY" time-title-format="MM/DD/YYYY" input-class="form-control"
                :input-attr="{ id: 'txtReportDateRange' }" :disabled="isGenerating" single></date-picker>
            </div>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col">
            <button type="button" class="btn btn-primary mr-2" @click="generateInventoryLevelValidator"
              :disabled="isGenerating">
              <i class="fas fa-spinner fa-spin mr-1" v-if="isGenerating" />
              Generate
            </button>
            <button type="button" class="btn btn-light" @click="showValidatorModal = !showValidatorModal"
              :disabled="isGenerating">
              Cancel
            </button>
          </div>
        </div>
      </form>
     </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import LottieAnimation from "lottie-web-vue";

export default {
    components: {
        LottieAnimation,
    },
    data() {
        return {
            value: [],
            reportType: "principal",
            reportDateRange: [new Date(), new Date()],
            // binCardReportPageItems: [],
            inventoryLevelReportPageItems: [],
            // stockOnHandReportModal: false,
            inventoryLevelReportModal: false,
            uploadModalShow: false,
            showValidatorModal: false,
            pageSize: 15,
            currentPage: 1,
            pageOfItems: [],
            isSearching: false,
            hasNoRecord: false,
            emailError: "",
            passwordError: "",
            isEdit: false,
            isGenerating: false,
            reportVersion: "2",
            file: null,
        };
    },
    computed: {
    ...mapState({
      principals: (state) => state.principalController.principals,
      // binCardReports: (state) => state.reportController.binCardReports,
      inventoryLevelReports: (state) => state.reportController.inventoryLevelReports,
      // stockOnHandReportFilter: (state) => state.reportController.stockOnHandReportFilter,
      inventoryLevelLast: (state) => state.reportController.inventoryLevelLast,
      inventoryLevelReportFilter: (state) => state.reportController.inventoryLevelReportFilter
    }),
    rows() {
      // return this.binCardReports.length;
      return this.inventoryLevelReports.length;
    },
    principalOptions() {
      return this.principals.map((mg) => ({
        ["name"]: mg.principalCode,
        ["code"]: mg.principalCode + "-001",
      }));
    },
  },
  validations: {
    stockOnHandReportFilter: {
      // dateRange: {
      //   required,
      // },
    },
    inventoryLevelReportFilter: {
        
    }
  },
  watch: {
    reportType: {
      handler() {
        this.value = [];
      },
      deep: true,
    },
  },
  methods: {
    paginationChanged: function (page) {
      if (page == null) {
        page = 1;
      }

      this.inventoryLevelReportPageItems = this.inventoryLevelReports.slice(
        (page - 1) * this.pageSize,
        page * this.pageSize
      );
    },
    handleFileUpload(event) {
      this.file = event.target.files[0];
    },
    generateReport() {
      this.$toast.open({
        message: "This feature is not yet implemented.",
        type: "info",
      });
    },

    async generateInventoryLevelReport() {
      this.$v.$touch();

      if (!this.$v.inventoryLevelReportFilter.$invalid) {
        this.isGenerating = true;
        this.inventoryLevelReportFilter.principalCode = this.value
          .map((mg) => mg.name)
          .join("~");

        var result = false;
          result = await this.$store
            .dispatch("reportController/GetInventoryLevelReports")
            .catch(async (error) => {
              this.isGenerating = false;
              await this.$store.dispatch("showOverlay", false);
              this.$toast.open({
                message: error.data.Message,
                type: "error",
              });
            });

        if (result) {
          this.inventoryLevelReportModal = false;
          this.reportType = "principal";
          this.isGenerating = false;
          this.value = [];

          this.$toast.open({
            message: "Report has been saved.",
            type: "success",
          });
        }
      }
    },

    async uploadFileV2() {
        var result = false;
        await this.$store.dispatch("showOverlay", true);

        result = await this.$store
        .dispatch("reportController/UploadInventoryLevelReports", this.file)
        .catch(async (error) => {
            await this.$store.dispatch("showOverlay", false);
            this.$toast.open({
            message: error.data,
            type: "error",
            });
        });

      if (result) {
        await this.searchFilter();
        await this.$store.dispatch("showOverlay", false);
        this.uploadModalShow = false;
        this.$toast.open({
          message: "Report has been uploaded.",
          type: "success",
        });
      }
    },
    async downloadTemplate() {
      this.isGenerating = true;

      var result = false;
      result = await this.$store
        .dispatch("reportController/GetInventoryLevelReports_Template")
        .catch(async (error) => {
          this.isGenerating = false;
          await this.$store.dispatch("showOverlay", false);
          this.$toast.open({
            message: error.data.Message,
            type: "error",
          });
        });

      if (result) {
        this.isGenerating = false;
        this.value = [];

        // this.$toast.open({
        //   message: "Report Templated has been downloaded.",
        //   type: "success",
        // });
      }

    },

    async generateInventoryLevelValidator() {
      this.$v.$touch();

      if (!this.$v.inventoryLevelReportFilter.$invalid) {
        this.isGenerating = true;

        var result = await this.$store
          .dispatch("reportController/GetInventoryLevelValidation")
          .catch(async (error) => {
            this.isGenerating = false;
            await this.$store.dispatch("showOverlay", false);
            this.$toast.open({
              message: error.data.Message,
              type: "error",
            });
          });

        if (result) {
          this.showValidatorModal = false;
          this.isGenerating = false;
          this.value = [];

          this.$toast.open({
            message: "Report has been saved.",
            type: "success",
          });
        }
      }
    },

    searchFilter: async function () {
      this.currentPage = 1;
      this.pageOfItems = [];
      this.isSearching = true;
      this.hasNoRecord = false;
      this.paginationChanged();
      this.isSearching = false;

      if (this.inventoryLevelReports.length == 0) {
          this.hasNoRecord = true;
      }
    }
  },
  async mounted() {
    await this.searchFilter();
    await this.$store
        .dispatch("reportController/GetInventoryLevel_Date")
        .catch((error) => {
          this.isSearching = false;
        });
    this.inventoryLevelReportFilter.date = this.inventoryLevelLast != null && this.inventoryLevelLast.dateAsOf != null ?
          new Date(this.inventoryLevelLast.dateAsOf) :
          new Date();
  },
};
</script>

<style scoped>
.mx-datepicker-range {
  width: 100%;
}
</style>